import React, { useMemo } from "react";
import useUserStore from "../Stores/userStore";
import { hasPermission } from "../hasPermissions";

export default function usePermissions(wrapper, feature) {
  const tenantId = useUserStore((state: any) => state.tenantId);
  const user = useUserStore((state: any) => state.user);
  const selectedWorkSpace = useUserStore(
    (state: any) => state.selectedWorkSpace
  );

  const permissions = useMemo(() => {
    if (selectedWorkSpace) {
      return hasPermission(user.permissions, wrapper, feature);
    }
  }, [user.permissions, tenantId]);

  return permissions;
}
